export default {
  header: {
    title: 'Gebruik je punten',
    balance: '{{value}} pts beschikbaar',
  },
  option_label: '{{value}} pts',
  buttons: {
    none: 'Geen',
  },
  toasts: {
    enabled: 'Spaarpunten succesvol toegepast',
    removed: 'Spaarpunten verwijderd',
  },
};
